// src/components/Login.jsx

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';
import { toast } from 'react-toastify';

export default function Login({ onLoggedIn }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loggingIn, setLoggingIn] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoggingIn(true);

    try {
      const response = await api.post('/agent/login', {
        email: form.email.trim(),
        password: form.password
      });

      const { token, agent } = response.data;
      localStorage.setItem('token', token);
      toast.success('Login successful!');
      onLoggedIn(agent);
      navigate('/dashboard');
    } catch (error) {
      console.error('❌ Login error:', error);
      toast.error('Login failed. Please check your credentials.');
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center' }}>🔐 Agent Login</h2>

      <form onSubmit={handleSubmit} style={{ marginTop: 30 }}>
        <div style={{ marginBottom: 15 }}>
          <label htmlFor="email">Email:</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="you@example.com"
            value={form.email}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label htmlFor="password">Password:</label>
          <input
            id="password"
            name="password"
            type="password"
            placeholder="Enter your password"
            value={form.password}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>

        <button
          type="submit"
          disabled={loggingIn}
          style={buttonStyle}
        >
          {loggingIn ? 'Logging in…' : 'Login'}
        </button>
      </form>

      <div style={linkRowStyle}>
        <Link to="/register" style={linkStyle}>Create Account</Link>
        <Link to="/forgot-password" style={linkStyle}>Forgot Password?</Link>
      </div>
    </div>
  );
}

// ─────── Styles ───────
const containerStyle = {
  maxWidth: 400,
  margin: '60px auto',
  padding: 20,
  border: '1px solid #ddd',
  borderRadius: 10,
  backgroundColor: '#fff',
  boxShadow: '0px 4px 20px rgba(0,0,0,0.05)'
};

const inputStyle = {
  display: 'block',
  width: '100%',
  padding: '10px',
  fontSize: '16px',
  borderRadius: 6,
  border: '1px solid #ccc',
  marginTop: 5
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#2C3E91',
  color: 'white',
  border: 'none',
  borderRadius: 6,
  fontSize: 16,
  cursor: 'pointer',
  marginTop: 10
};

const linkRowStyle = {
  marginTop: 20,
  display: 'flex',
  justifyContent: 'space-between'
};

const linkStyle = {
  color: '#2C3E91',
  textDecoration: 'none',
  fontSize: 14
};
